module.exports = __webpack_public_path__ + "b5b0864b002b81baba81c70d16e27e40.svg";